import { ConfigProvider, Select } from "antd";

export default function CustomSelect({
  placeholder,
  options = [],
  onChange,
  value,
}) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#00397d", // ✅ ใช้เป็นสี focus border ของ DatePicker
        },
      }}
    >
      <Select
        onChange={onChange}
        value={value}
        showSearch
        placeholder={placeholder}
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        options={options}
      />
    </ConfigProvider>
  );
}
